import { type ProductMaturityHistoryGroup } from '@/domain/products/types';
import { Column } from 'primereact/column';
import { DataTable, type DataTableExpandedRows, type DataTableValueArray } from 'primereact/datatable';
import { useState } from 'react';

import MaturityHistoryItem from './MaturityHistoryItem';

interface MaturityHistoryProps {
  history: ProductMaturityHistoryGroup[];
}

const groupTemplate = (rowData: ProductMaturityHistoryGroup) => `${rowData.group} [${rowData.items.length}]`;

const rowExpansionTemplate = (rowData: ProductMaturityHistoryGroup) => <MaturityHistoryItem items={rowData.items} />;

const MaturityHistoryDataTable = ({ history }: MaturityHistoryProps) => {
  const [expandedRows, setExpandedRows] = useState<DataTableValueArray | DataTableExpandedRows | undefined>([]);
  return (
    <DataTable
      value={history}
      dataKey="group"
      size="small"
      expandedRows={expandedRows}
      onRowToggle={(e) => {
        setExpandedRows(e.data);
      }}
      rowExpansionTemplate={rowExpansionTemplate}
      showHeaders={false}
    >
      <Column expander style={{ width: '3em' }} />
      <Column field="group" body={groupTemplate} />
    </DataTable>
  );
};

export default MaturityHistoryDataTable;
